import EventProvider from '@ui5/webcomponents-base/dist/EventProvider';

export const MediaEventProvider = new EventProvider();
